export default "__VITE_ASSET__DdynG0P2__"